(function() {
    'use strict';

    angular.module('order')
        .controller('OrderSendCheckController', OrderSendCheckController);

    OrderSendCheckController.$inject = ['$state', 'orderDataSrvc', 'notificationSrvc', 'orderSendMessagesConst', 'errorNotificationSrvc'];

    function OrderSendCheckController($state, orderDataSrvc, notificationSrvc, orderSendMessagesConst, errorNotificationSrvc) {
        var self = this;

        self.serverErrors = {
            pk: [],
            nonFieldErrors: []
        };
        self.sendData = {
            pk: null
        };

        self.onSend = onSend;
        self.cleanErrors = cleanErrors;

        function onSend() {
            return orderDataSrvc.sendCheck({
                pk: self.sendData.pk
            }).$promise.then(
                function(response) {
                    $state.go('layout.order.sendUps', {pk: response.pk});
                },
                function(response) {
                    errorNotificationSrvc.displayErrors(response.data);
                    self.serverErrors.pk = response.data;
                }
            );
        }

        function cleanErrors(key) {
            self.serverErrors[key] = [];
        }
    }
})();
